<template>
    <history-table>
        <template #columns>
            <th>Date</th>
            <th>Status</th>
            <th>User</th>
            <th></th>
        </template>

        <finance-table-row
            v-for="entry in data.entries"
            :key="entry.id"
            :data="data"
            :entry="entry"
        />
    </history-table>
</template>

<script>
import HistoryTable from '../HistoryTable.vue';
import FinanceTableRow from './FinanceTableRow.vue';

export default {
    components: { HistoryTable, FinanceTableRow },
    props: {
        data: Object,
    },
};
</script>
